import React from "react";

import {Card, CardContent, Box, makeStyles, useMediaQuery, Grid, Typography, Button} from "@material-ui/core";

import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import { useLightbox } from "simple-react-lightbox";
import {setPaymentType, setSelectedCard} from "../../redux/credits/credits.reducers";
import {useHistory} from "react-router-dom";
import API from "../../helpers/apiHelpers";

const useStyle = makeStyles((theme) => ({
    buttons: {
        width: 184,
        marginBottom: 10,
        marginRight: 13
    },
    buttonNotes: {
        width: 184,
        padding: "12px 10px",
        marginBottom: 10
    },
    cardWrapper:{
        display : "flex",
        justifyContent: "space-between",
        padding: '30px 0',
        borderBottom: '1px solid #273878',
        alignItems: 'center',
        '&:last-of-type': {
            border: 'none'
        }
    },
    cardName:{
        color: '#273878',
        fontFamily: 'NotoSerifDisplay',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
    },
    deleteBtn:{
        color: '#FF6D6D',
        border: '1px solid #FF6D6D',
        '&:hover':{
            color: 'white',
            backgroundColor: '#FF6D6D',
            boxShadow: 'none'
        },
        '&:active':{
            color: '#777777',
        }
    }
}));



const CreditCardItem = ({item=null, deleteCreditCard=null, isChangeCreditCard=false}) => {
    const classes = useStyle();
    const theme = useTheme();
    const history = useHistory();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const user = useSelector((state: RootState) => state?.user);
    const paymentType = useSelector((state: RootState) => state?.credits.paymentType)
    const dispatch = useAppDispatch();
    const { openLightbox } = useLightbox();


    return (
            <Grid className={classes.cardWrapper}>
                <Grid >
                <Grid md={12}>
                    <Typography className={classes.cardName}>
                       {item.cardType} Ending in {item.lastFourDigits}
                    </Typography>
                </Grid>
                <Grid md={12}>
                    <Typography className={classes.cardName} style={{marginTop: '17px'}}>
                         Expires {`${item.expirationMonth}/${item.expirationYear}`}
                    </Typography>
                </Grid>
                </Grid>
                <Grid item md={3}>
                    {!!isChangeCreditCard ?
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                dispatch(setSelectedCard(item))
                                await API.updateCreditCard(item.id, true)
                                history.push(`/invoice?type=${paymentType}`);
                                dispatch(setPaymentType(""));
                            }}
                        >
                            Select
                        </Button>
                        : <Button
                        type="button"
                        variant="contained"
                        className={classes.deleteBtn}
                        onClick={() => deleteCreditCard(item.id)}
                    >
                        Delete
                    </Button>}
                </Grid>

            </Grid>
    );
};

export default CreditCardItem;
